import { baseApi } from "./apiConfig";

/**
 * Resolves a short URL code to the original long URL
 * @param {string} code - The short hashed URL code (e.g., "jBBlsI")
 * @returns {Promise<object>} - Response with status and data (long URL)
 */
export const resolveShortUrl = async (code) => {
  const response = await baseApi.get(`/portal/getLongUrl/${code}`);
  return response.data;
};
